import { Dispatcher } from 'flux';
import assign from 'object-assign';
import AdminConstants from '../constants/AdminConstants';

const PayloadSources = AdminConstants.PayloadSources;

const AdminAppDispatcher = assign(new Dispatcher(), {

  /**
  * @param {object} action The details of the action, including the action's
  * type and additional data coming from the server.
  */
  handleServerAction(action) {
    const payload = {
      source: PayloadSources.SERVER_ACTION,
      action,
    };
    // console.log('dispatching payload', payload);
    this.dispatch(payload);
  },

  /**
  * @param {object} action The details of the action, including the action's
  * type and additional data coming from the view.
  */
  handleViewAction(action) {
    const payload = {
      source: PayloadSources.VIEW_ACTION,
      action,
    };

    // delay to avoid error with starting dispatch when there's
    // ongoing dispatch
    setTimeout(() => { this.dispatch(payload); }, 1);
  },

});

export default AdminAppDispatcher;
